import { render, staticRenderFns } from "./notificationManagement.vue?vue&type=template&id=55ac509e&"
import script from "./notificationManagement.vue?vue&type=script&lang=js&"
export * from "./notificationManagement.vue?vue&type=script&lang=js&"
import style0 from "./notificationManagement.vue?vue&type=style&index=0&id=55ac509e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports